module.exports = __webpack_public_path__ + "static/media/register.defcc6b4.svg";